@if (!fullScreen) {
    @if (productsData == null) {
        <div class="h-100 py-3 position-relative">
            <app-pg-loading [isOverlay]="true"></app-pg-loading>
        </div>
    }
    @else {
        <div class="TotemWidget TotemWidgetClusters">
            @if (title || subtitle) {
                <div class="TotemWidgetClusters-Header">
                    @if (title) {
                        <h3 class="TotemWidgetClusters-Title m-0">{{ title | locTranslate | stripHTML }}</h3>
                    }
                    @if (subtitle) {
                        <div class="TotemWidgetClusters-Subtitle">{{ subtitle | locTranslate | stripHTML }}</div>
                    }
                </div>
            }
            @if (clusters?.length) {
                <div class="TotemWidgetClusters-Grid"> 
                    <!-- NB: questa è se reverso da css per mantenere l'estetica con i "resti" per riga all'inizio -->
                    @for (cluster of clusters | customFn:reverseArray; track cluster; let i = $index) {
                        <button type="button" class="TotemWidgetClusters-Item" [style.backgroundColor]="cluster.color" (click)="onClusterClick(cluster)">
                            <div class="TotemWidgetClusters-Item-Media">
                                @if (hasImage(cluster)) {
                                    <img class="TotemWidgetClusters-Item-Image" [src]="cluster.image" [attr.alt]="cluster.label || ''">
                                }
                                @else {
                                    <i class="{{ getIconClass(cluster.icon) }} TotemWidgetClusters-Item-Icon"></i>
                                }
                            </div>
                            <span class="TotemWidgetClusters-Item-Label">{{ cluster.label | locTranslate | stripHTML }}</span>
                        </button>
                    }
                </div>
            }
        </div>
    }
}
@else {
    @if(selectedProductId) {
        @if (isLoadingProduct) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!isLoadingProduct) {
            <app-ef-product appMode="iframekiosk" [productData]="selectedProductData" [supplierData]="selectedProductSupplierData" [hasClose]="true" (doClose)="selectedProductId = null" (showProduct)="onShowProduct($event)"></app-ef-product>
        }
    }
    @else if (selectedCluster) {
        <div class="TotemWidgetClusters TotemWidgetClusters--FullScreen">
            @if (hasClusterHeader(selectedCluster)) {
                <div class="TotemWidgetClusters-FullScreen-Header container py-3">
                    <div class="TotemWidgetClusters-FullScreen-Title {{ selectedCluster.cover ? 'TotemWidgetClusters-FullScreen-Title--HasCover' : '' }}"
                        [style.backgroundImage]=" selectedCluster.cover ? 'url(' + selectedCluster.cover + ')' : null">
                        <h3>{{ (selectedCluster.title || selectedCluster.label) | locTranslate | stripHTML }}</h3>

                        @if(selectedCluster.cover) {
                            <div>
                                <div class="TotemWidgetClusters-Item" [style.backgroundColor]="selectedCluster.color">
                                    <div class="TotemWidgetClusters-Item-Media">
                                        @if (hasImage(selectedCluster)) {
                                            <img class="TotemWidgetClusters-Item-Image" [src]="selectedCluster.image" [attr.alt]="selectedCluster.label || ''">
                                        }
                                        @else {
                                            <i class="{{ getIconClass(selectedCluster.icon) }} TotemWidgetClusters-Item-Icon"></i>
                                        }
                                    </div>
                                    <span class="TotemWidgetClusters-Item-Label">{{ selectedCluster.label | locTranslate | stripHTML }}</span>
                                </div>
                            </div>
                        }
                    </div>
                 
                    @if (selectedCluster.video) {
                        <div class="TotemWidgetClusters-FullScreen-Video mb-3">
                            <video controls [poster]="selectedCluster.videoPoster | locTranslate">
                                <source [src]="selectedCluster.video | locTranslate" type="video/mp4">
                            </video>
                        </div>
                    }
                    @if (selectedCluster.description) {
                        <div class="TotemWidgetClusters-FullScreen-Description" [innerHTML]="selectedCluster.description | locTranslate"></div>
                    }
                </div>
            }
            <app-ef-list [full]="true" [productsData]="filteredData" (showProduct)="onShowProduct($event)"></app-ef-list>
        </div>
    }
}
